"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var x_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/x"));
var S = __importStar(require("./LftModalBase.styles"));
var LftIconButton_1 = __importDefault(require("../LftIconButton"));
var LftBackdrop_1 = __importDefault(require("../LftBackdrop"));
var use_key_press_1 = require("../../utils/hooks/use-key-press");
var LftModalBase = function (_a) {
    var _b = _a.ariaLabel, ariaLabel = _b === void 0 ? 'modal' : _b, bgColor = _a.bgColor, children = _a.children, dataSection = _a.dataSection, dataTestId = _a.dataTestId, hiddenCloseButton = _a.hiddenCloseButton, height = _a.height, id = _a.id, _c = _a.visible, visible = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'lg' : _d, width = _a.width, lftClose = _a.lftClose;
    var dataElement = dataSection === null || dataSection === void 0 ? void 0 : dataSection.replace('section_', '');
    var escapePress = (0, use_key_press_1.useKeyPressDocument)('Escape');
    (0, react_1.useEffect)(function () {
        if (escapePress && visible) {
            return lftClose && lftClose();
        }
    }, [escapePress]);
    if (dataSection) {
        if (dataSection.startsWith('section_')) {
            console.warn('Não é necessário mais o prefixo section_ no atributo dataSection');
        }
        else
            dataSection = "section_" + dataSection;
    }
    if (!visible) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(LftBackdrop_1.default, __assign({ visible: visible, clickOutside: !hiddenCloseButton, lftClick: lftClose }, { children: (0, jsx_runtime_1.jsx)(S.ModalBase, __assign({ "aria-label": ariaLabel, "data-lift": "lft-modalbase", "data-section": dataSection, "data-testid": dataTestId ? dataTestId : id && id, id: id, size: size, role: "dialog", width: width, height: height }, { children: (0, jsx_runtime_1.jsxs)(S.ModalVisible, __assign({ bgColor: bgColor, size: size, tabIndex: -1, width: width, height: height }, { children: [children, (0, jsx_runtime_1.jsx)(S.ModalButton, __assign({ size: size }, { children: !hiddenCloseButton && ((0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(LftIconButton_1.default, { alt: 'Botão Fechar', ariaLabel: 'Botão Fechar', bgColor: bgColor, dataElement: dataElement && 'close-' + dataElement, icon: x_1.default, size: 'lg', lftClick: lftClose }, void 0) }, void 0)) }), void 0)] }), void 0) }), void 0) }), void 0));
};
exports.default = LftModalBase;
